/** Values of a template's placeholders: {{prenom}}, {{entreprise}}... */
export interface TemplateVariables {
  prenom?: string | null;
  nom?: string | null;
  entreprise?: string | null;
  mon_prenom?: string | null;
  mon_nom?: string | null;
}

/** Replaces each {{placeholder}} with its value, or nothing when it has none. */
export const fillTemplate = (text: string, variables: TemplateVariables) =>
  text.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (_, name: string) => {
    const value = variables[name.toLowerCase() as keyof TemplateVariables];
    return value ?? "";
  });

/** « Re: » subject of a reply, without stacking them. */
export const replySubject = (subject?: string | null) => {
  const base = (subject ?? "").trim();
  return /^re\s*:/i.test(base) ? base : `Re: ${base}`;
};
